import Alelo from '../../assets/icons/card/alelo.webp';
import Amex from '../../assets/icons/card/amex.webp';
import Aura from '../../assets/icons/card/aura.jpeg';
import Ben from '../../assets/icons/card/ben.webp';
import Diners from '../../assets/icons/card/diners.webp';
import Discover from '../../assets/icons/card/discover.webp';
import Elo from '../../assets/icons/card/elo.png';
import Flash from '../../assets/icons/card/flash.webp';
import Hipercard from '../../assets/icons/card/hipercard.webp';
import Jcb from '../../assets/icons/card/jcb.png';
import Mastercard from '../../assets/icons/card/mastercard.webp';
import Sodexo from '../../assets/icons/card/sodexo.webp';
import Visa from '../../assets/icons/card/visa.webp';
import VR from '../../assets/icons/card/vr.webp';

import Lalamove from '../../assets/icons/delivery/lalamove.webp';
import Mottu from '../../assets/icons/delivery/mottu.webp';
import BoxDelivery from '../../assets/icons/delivery/box-delivery.webp';
import Borzo from '../../assets/icons/delivery/borzo.webp';
import UberDirect from '../../assets/icons/delivery/uber-direct.webp';
import FoodyDelivery from '../../assets/icons/delivery/foody-delivery.webp';
import TruckDefault from '../../assets/icons/delivery/truck.svg';

import moment from 'moment';

import 'moment/locale/pt-br';
moment.locale('pt-br');

export const mapFetchOrdersListRequest = ({
  initialDate,
  finalDate,
  searchTerm,
  storeId,
  id,
  modality,
  schedule
}) => {
  const formatDate = (date) => (date ? moment(date).format('YYYY-MM-DD') : undefined);
  const response = {
    datainicio: formatDate(initialDate),
    datafinal: formatDate(finalDate),
    Comandaid: id || undefined,
    ModalidadeRetiradaId: modality,
    Agendamento: schedule
  };
  return storeId ? { ...response, EstabelecimentoId: storeId } : response;
};

export const mapFetchOrdersListResponse = (response) => {
  const data = response && response['Data'];
  if (!Array.isArray(data)) return [];
  return data.map((dataItem) => ({
    id: dataItem['ComandaId'],
    modality: getModality(dataItem.ModalidadeRetiradaId),
    status: dataItem['StatusPedido'],
    deliveryForecast: dataItem['PrevisaoEntrega']
      ? moment(dataItem['PrevisaoEntrega']).format('DD MMM YYYY - HH:mm')
      : undefined,
    date: dataItem['Data'] ? moment(dataItem['Data']).format('DD/MM/YYYY - HH:mm') : undefined,
    scheduleDate: dataItem['DataAgendamento'] ? dataItem['DataAgendamento'] : undefined,
    cupom: dataItem['ValorDesconto'],
    client: dataItem['NomeUsuario'],
    rating: dataItem['Avaliacao'],
    paymentMethod: dataItem['FormaPagamento'],
    value: dataItem['Valor'],
    paymentStatus: dataItem['StatusComanda']
  }));
};

export const mapFetchOrderDetailResponse = (card) => {
  if (!card) return undefined;

  const pedidos = Array.isArray(card.Pedidos) ? card.Pedidos : [];
  const cardOrders = pedidos.map((order) => ({
    quantity: order.QuantidadeProduto,
    name: order.NomeProduto,
    value: order.ValorProduto,
    note: order.Observacao,
    complements: (Array.isArray(order.Complementos) ? order.Complementos : []).map((complement) => ({
      name: complement.NomeComplemento,
      quantity: complement.QuantidadeComplemento,
      value: complement.ValorComplemento
    }))
  }));

  const payment = getPaymentType(card.TipoPagamentoId);
  const isRefundAvailable = card.PagoOnline && ['Cartão de Crédito', 'Alelo Virtual', 'Sodexo', 'VR'].includes(payment);
  
  const fetch = {
    cardId: card.ComandaId,
    createdAt: moment(card.DataCriacao).format('DD MMM YYYY - HH:mm:ss'),
    appointmentDate: card.DataAgendamento ? card.DataAgendamento : null,
    type: (card.HistoricoStatusBalcao && card.HistoricoStatusBalcao.length > 0) ? 'Balcão' : 'Delivery',
    modality: getModality(card.ModalidadeRetiradaId),
    subTotal: card.SubTotal,
    deliveryTax: card.ValorTaxaEntrega,
    discount: card.ValorDesconto,
    total: card.Total,
    message: card.Message,
    thing: card.Troco,
    status: getStatus(card.HistoricoStatusBalcao || [], card.HistoricoStatusDelivery || []),
    payment,
    refund: {
      isAvailable: isRefundAvailable
    },
    paymentStatus: card.StatusPagamento,
    isPaidOnline: card.PagoOnline,
    cardCompany: getCardCompany(card.BandeiraId),
    cpfNote: card.CpfNaNota,
    coupon: card.NomeCupom,
    deliveryPlatform: {
      url: card.UrlAcompanhamentoPlataformaDelivery,
      name: card.NomePlataformaDelivery,
      src: getDeliveryPlatformImage(card.NomePlataformaDelivery)
    },
    user: {
      name: card.NomeUsuario,
      phone: card.TelefoneUsuario ? card.TelefoneUsuario.replace('+55', '') : null,
      email: card.EmailUsuario,
      address: card.EnderecoUsuario,
      quantityOrders: card.QuantidadePedidosUsuario
    },
    order: cardOrders
  };

  return fetch;
};

const getModality = (type) => {
  switch (type) {
    case 1:
      return 'Comer aqui';
    case 2:
      return 'Quero levar';
    case 3:
      return 'Receber no escritório';
    case 4:
      return 'Delivery';
    case 5:
      return 'Kilo';
    default:
      return '';
  }
};

const getStatus = (counter, delivery) => {
  const counterList = Array.isArray(counter) ? counter : [];
  const deliveryList = Array.isArray(delivery) ? delivery : [];
  if (counterList.length > 0) {
    return {
      type: 'counter',
      history: counterList.map((count) => ({
        status: count.Status,
        date: moment(count.Data).format('DD MMM YYYY - HH:mm:ss')
      }))
    };
  }

  return {
    type: 'delivery',
    history: deliveryList.slice(0, 5).map((deli) => ({
      status: deli.Status,
      date: moment(deli.Data).format('DD MMM YYYY - HH:mm:ss')
    }))
  };
};

const getPaymentType = (paymentId) => {
  switch (paymentId) {
    case 19:
      return 'Pix';
    case 15:
      return 'Fidelidade';
    case 14:
      return 'Sodexo';
    case 10:
      return 'Cartão de Débito';
    case 9:
      return 'Promocional Cupom';
    case 8:
      return 'Pagamento VoceQPad para Testes';
    case 6:
      return 'Visa Checkout';
    case 5:
      return 'VR';
    case 4:
      return 'Alelo Virtual';
    case 3:
      return 'Ticket Pay';
    case 2:
      return 'Cartão de Crédito';
    default:
      return 'Não definido';
  }
};

const getCardCompany = (cardCompanyId) => {
  switch (cardCompanyId) {
    case 32:
      return {
        label: 'Flash',
        src: Flash
      };
    case 31:
      return {
        label: 'Hipercard',
        src: Hipercard
      };
    case 30:
      return {
        label: 'Sodexo',
        src: Sodexo
      };
    case 29:
      return {
        label: 'Ben',
        src: Ben
      };
    case 28:
      return {
        label: 'Alelo',
        src: Alelo
      };
    case 27:
      return {
        label: 'VR Refeição',
        src: VR
      };
    case 19:
      return {
        label: 'JCB',
        src: Jcb
      };
    case 18:
      return {
        label: 'Aura',
        src: Aura
      };
    case 16:
      return {
        label: 'Elo',
        src: Elo
      };
    case 15:
      return {
        label: 'Discover',
        src: Discover
      };
    case 5:
      return {
        label: 'American Express',
        src: Amex
      };
    case 4:
      return {
        label: 'MasterCard',
        src: Mastercard
      };
    case 3:
      return {
        label: 'Visa',
        src: Visa
      };
    case 2:
      return {
        label: 'Diners Club',
        src: Diners
      };
    default:
      return null;
  }
};

const getDeliveryPlatformImage = (name) => {
  if (!name) return TruckDefault;

  switch (name) {
    case 'Lalamove':
      return Lalamove;

    case 'Mottu':
      return Mottu;

    case 'Box Delivery':
      return BoxDelivery;

    case 'Borzo':
      return Borzo;

    case 'Uber Direct':
      return UberDirect;

    case 'FoodyDelivery':
      return FoodyDelivery;

    default:
      return TruckDefault;
  }
};
